<script>
import PfAll from './components/PfAll.vue'

export default {
  data() {
    return {
      drawer: null,
      nav_lists:[
        {name:'ピアノ修理', icon: 'mdi-tools', link:'#repair'},
        {name:'ピアノクリーニング', icon: 'mdi-vacuum',link:'#cleaning'},
//        {name:'ピアノ販売', icon: 'mdi-bullhorn-outline',link:'#sale'},
        {name:'ピアノ塗装', icon: 'mdi-brush-variant',link:'#paint'},
        {name:'ピアノ調律', icon: 'mdi-tune-vertical',link:'#tune'},
        {name:'ピアノ教室', icon: 'mdi-piano',link:'#school'},
        {name:'消音ユニット取り付け', icon: 'mdi-volume-off',link:'#silent'},
        {name:'グランフィール取り付け', icon: 'mdi-mace',link:'#gran'},
        {name:'ピアピットについて', icon: 'mdi-google-downasaur',link:'#about'},
      ],
    }
  },
  components: {
    PfAll
  },
  methods: {
    menuOn(link) {
      this.$vuetify.goTo(link);
      this.drawer = null;
    },
  },
}
</script>

<template>
  <v-app>
    <v-navigation-drawer app v-model="drawer" clipped color="orange lighten-5">
      <v-container>
        <!-- <v-list-item> -->
        <!--   <v-list-item-content> -->
        <!--     <v-list-item-title class="title grey--text"> -->
        <!--       リスト -->
        <!--     </v-list-item-title> -->
        <!--   </v-list-item-content> -->
        <!-- </v-list-item> -->

        <!-- <v-divider></v-divider> -->

        <v-list dense nav>
          <v-list-item v-for="nav_list in nav_lists" :key="nav_list.name"  @click="menuOn(nav_list.link)">
            <v-list-item-icon>
              <v-icon>{{ nav_list.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ nav_list.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-container>
    </v-navigation-drawer>

    <v-app-bar color="#6cffccdd" app clipped-left>
      <v-app-bar-nav-icon @click="drawer=!drawer"></v-app-bar-nav-icon>
      <v-toolbar-title class="font9 pl-0">PIAPIT</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn text class="font7">TEL:0120-311-054</v-btn>
      </v-toolbar-items>
    </v-app-bar>
    <v-footer color="#6cffccdd" class="font9" app>PIAPIT
      <v-spacer></v-spacer>
      <span class="font5">〒270ー1364 千葉県印西市浦幡新田50</span>

    </v-footer>
    <v-main class="indigo lighten-5">
      <PfAll />
    </v-main>
  </v-app>
</template>

<style>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100;300;400;500;700;900&display=swap');
.v-application {
  font-family: "Noto Sans JP", sans-serif !important;
}
.font1 {
  font-weight:100;
}
.font3 {
  font-weight:300;
}
.font4 {
  font-weight:400;
}
.font5 {
  font-weight:500;
}
.font7 {
  font-weight:700;
}
.font9 {
  font-weight:900;
}

</style>
